import React from "react"
import { getAssetPath } from "../../utils/assets"

export const srcLink = title => {
  const assetName = `icn-10dwc-${title}`
  return getAssetPath(assetName)
}

function WellbeingCardHeading({ title }) {
  return (
    <div>
      <img className="mr-3" src={srcLink(title)} width={48} />
      {/* <img className="mr-3" src={`/assets/icons/10dwc/icn-10dwc-${title}.svg`} width={48} /> */}
      {title.charAt(0).toUpperCase() + title.slice(1)}
      {" "}
      Wellbeing
      {" "}
      {title === "global" && "Scale"}
    </div>
  )
}

export default WellbeingCardHeading